import AdminSimulatorRepository from '../../domain/repositories/AdminSimulatorRepository';
import AdminSimulatorDataStore from '../datastores/AdminSimulatorDataStore';
import AdminSimulatorDataStoreFactory from '../factories/AdminSimulatorDataStoreFactory';

export default class AdminSimulatorDataRepository
  implements AdminSimulatorRepository
{
  getStudentInformationById(studentId: string) {
    const adminSimulatorDataStore: AdminSimulatorDataStore =
      AdminSimulatorDataStoreFactory.create();
    return adminSimulatorDataStore.getStudentInformationById(studentId);
  }
}
